import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import useHttp from "../../../hooks/useHttp";
import store from "../../../store";

import "../../../assets/css/utility/table.css";
import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/transaction-page.css";

import WithdrawList from './WithdrawList'
import { WITHDRAW_POST_URL, SHIPPER_PROFILE_URL, CARRIER_PROFILE_URL } from "../../../utils/api-ends";
import { withdrawListValue } from "../../../store/slices/withdraw";


const WithdrawForm = () => {

	const { error, sendRequests } = useHttp();
	const [withdrawError, setWithdrawError] = useState([]);
	const [successMessage, setSuccessMessage] = useState(null);
	// const dispatch = useDispatch();
	const withdrawData = useSelector((state) => state.withdraw);

	const { sendRequests: getUserBalance } = useHttp();
	const userData = useSelector((state) => state.basicInfo.userDetails);
	const [withdrawAmount, setWithdrawAmount] = useState("");

	useEffect(() => {

		let url = "";
		//set url depending on user type
		if (userData?.user_type === "shipper") {
			url = SHIPPER_PROFILE_URL;
		} else {
			url = CARRIER_PROFILE_URL;
		}

		// set user values in state
		const response = (data) => {
			setWithdrawAmount(data.data.user_obj.balance)
		};

		// Send request to get profile info
		getUserBalance(
			{
				url: url,
				method: "GET",
			},
			response
		);
	}, [userData?.user_type]);

	const onChangeWithdrawAmount = (e) => {
		setWithdrawAmount(e.target.value);
	}

	const onSubmit = (data) => {

		const response = (data) => {

			setSuccessMessage("Successfully Send Withdraw Request")
			setWithdrawError(null)
			setTimeout(function () { setSuccessMessage("") }, 5000);

			document.getElementById("withdraw-amount-input").value = " "

			store.dispatch(
				withdrawListValue({
					withdrawValue: [data, ...withdrawData.withdrawList],
				})
			);

		}

		sendRequests(
			{
				method: "post",
				url: WITHDRAW_POST_URL,
				data: {
					amount: withdrawAmount,
				},
			},
			response
		);

	}


	useEffect(() => {
		if (error) {
			if (error.amount) {
				setWithdrawError(error.amount);
				setSuccessMessage("")
			} else if (error.non_field_errors) {
				setWithdrawError(error.non_field_errors)
				setSuccessMessage("")
			}
		}

	}, [error]);


	// Show or hide error messages on mouse enter or leave
	const showErrorMessage = (e) =>
		e.currentTarget.setAttribute("show-tittle", "true");
	const hideErrorMessage = (e) =>
		e.currentTarget.setAttribute("show-tittle", "false");


	return (
		<>
			<section className="transaction-section">
				<div className="container theme-section">
					<h1 className="tr-title text-center"> Withdraw </h1>
					<div className="tr-center-box">
						<div className="col-lg-4 col-md-8 col-12">
							<div className="input-box-area" single-labe="true">
								<label>Amount Of Money</label>

								<p className="auth-instruction SuccessMessage_SuccessMsg__fTMdE withdrawAmount-success-message">{successMessage}</p>

								<input type="text" placeholder="Amount Of Money" id="withdraw-amount-input" value={withdrawAmount} onChange={onChangeWithdrawAmount} />

								{withdrawError?.length > 0 && (
									<div className="error" show-tittle="false" onMouseEnter={showErrorMessage} onMouseLeave={hideErrorMessage}>
										<i className="fa-solid fa-circle-exclamation"></i>
										{withdrawError?.map((error, index) => (
											<p className="auth-error" key={index}>
												{error}
											</p>
										))}
									</div>
								)}
							</div>

							<div className="multiple-btn mt-4">
								<button className="m-0" onClick={onSubmit}>Withdraw</button>
							</div>
						</div>
					</div>
				</div>
			</section>


			<WithdrawList />
		</>
	)
}

export default WithdrawForm